import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, CssBaseline } from '@mui/material';

const SuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login');
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container component="main" maxWidth="sm" style={{ height: '52vh', display: 'flex', alignItems: 'center' }}>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: 'white',
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography component="h1" variant="h5">
          Password Reset Successfully
        </Typography>
        <Typography sx={{ mt: 2 }}>
          Your password has been reset successfully. You will be redirected to the login page in 10 seconds.
        </Typography>
      </Box>
    </Container>
  );
};

export default SuccessPage;
